import firebase from 'firebase/app'
import { getModule } from 'vuex-module-decorators'
import router from '@/router'
import user from '../store/modules/user'

firebase.auth().onAuthStateChanged((firebaseUser) => {
  const actionToDispatch = (firebaseUser === null || firebaseUser === undefined) ? 'logout' : 'login'
  const User = getModule(user)
  console.log('right now router is: ', router)
  console.log('app.', router.app)
  if (actionToDispatch === 'login' && firebaseUser) {
    User.setUser(firebaseUser.uid)
  } else {
    User.clearUser()
    // User.setUserNull()
    const currentRouter = router.app.$route
    console.log('app.', router.app)
    // console.log(currentRouter.meta, 'is the meta')
    if (currentRouter && !(currentRouter.meta && currentRouter.meta.authNotRequired)) {
      router.push('/login')
    }
  }
})
